import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const innerWrapperFn = /* @__PURE__ */ createRecipe('inner-wrapper', {}, [])

const innerWrapperVariantMap = {}

const innerWrapperVariantKeys = Object.keys(innerWrapperVariantMap)

export const innerWrapper = /* @__PURE__ */ Object.assign(memo(innerWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'innerWrapper',
  __getCompoundVariantCss__: innerWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: innerWrapperVariantKeys,
  variantMap: innerWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, innerWrapperVariantKeys)
  },
  getVariantProps: innerWrapperFn.getVariantProps,
})